import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CircularProgress, Stack, Typography } from '@monorepo/nova-ui';

export const SupportedSymbolsLoading: FC = () => {
  const { t } = useTranslation(['common']);

  return (
    <Stack alignItems="center" justifyContent="center" minHeight={200} gap={2}>
      <CircularProgress size={48} />
      <Typography variant="h6" align="center">
        {t('common:loading')}
      </Typography>
    </Stack>
  );
};
